import PropTypes from 'prop-types';
import { getConfig } from '../config.js';
import getClientSlug from '../helpers/clientSlug.js';
import { buildJsonHeaders } from '../helpers/apiHeaders';

// In-memory cache for subscription/maintenance status so we don't spam `check_status`
// on every mount/navigation.
let checkStatusPromise = null;
let lastKnownGateError = null; // e.g. { type: 'error', error_code: 'subscription_status', message: '...' }

const isGateError = (res) =>
	res &&
	res.type === 'error' &&
	(res.error_code === 'subscription_status' ||
		String(res.message || '')
			.toLowerCase()
			.includes('site under maintenance'));

export function __resetApiServicewtCacheForTests() {
	checkStatusPromise = null;
	lastKnownGateError = null;
}

export default async function apiServicewt(quary) {
	const webLink = getConfig().REACT_APP_WEB_LINK;
	const slug = getClientSlug();

	// If we already know the site is gated (maintenance/subscription), avoid calling other APIs.
	if (quary?.action !== 'check_status' && lastKnownGateError) {
		return lastKnownGateError;
	}

	// Only run `check_status` once per app session.
	if (quary?.action === 'check_status') {
		if (!checkStatusPromise) {
			checkStatusPromise = (async () => {
				const payload0 = slug ? { ...quary, slug } : quary;
				const headers = await buildJsonHeaders();
				const result0 = await fetch(webLink, {
					method: 'post',
					headers,
					body: JSON.stringify(payload0),
				});
				const response0 = await result0.json();
				if (isGateError(response0)) {
					lastKnownGateError = response0;
				}
				return response0;
			})();
		}

		return checkStatusPromise;
	}

	const payload = slug ? { ...quary, slug } : quary;
	const headers = await buildJsonHeaders();
	const result = await fetch(webLink, {
		method: 'post',
		headers,
		body: JSON.stringify(payload),
	});
	const responce = await result.json();
	if (isGateError(responce)) {
		lastKnownGateError = responce;
	}
	return responce;
}

apiServicewt.propTypes = {
	quary: PropTypes.isRequired,
	navigator: PropTypes.isRequired,
};
